import React from 'react';
import ReactDOM from 'react-dom';
import { QueryClient, QueryClientProvider } from 'react-query';
import { BrowserRouter } from 'react-router-dom';

// Components.
import App from './app';

const element = document.getElementById('kff-health-system-tracker-nhse-interactive');
if (element) {
  const definitions = element.dataset.definitions || '';

  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        // Turn off refetches or slow them down to 1 hour since data doesn't change very often.
        refetchInterval: 3600000,
        refetchIntervalInBackground: 3600000,
        refetchOnMount: false,
        refetchOnReconnect: false,
        refetchOnWindowFocus: false,
      },
    },
  });

  const WrappedApp = () => (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App definitions={definitions} />
      </BrowserRouter>
    </QueryClientProvider>
  );

  ReactDOM.render(
    <WrappedApp />,
    element,
  );
}
